import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Pagination from 'react-js-pagination'
import { Button } from 'react-bootstrap'
import classnames from 'classnames'
import qs from 'querystring'
import ObjectUtil from '@leverege/object-util'
import ArrayUtil from '@leverege/array-util'
import { Text } from '@leverege/ui-elements'

import DeviceItem from './DeviceItem'
import NoDevicesView from './NoDevicesView'
import { DeviceFactory } from '~/editors/device'
import { DeviceUpdater, DeviceActions, BreadcrumbActions, HistoryActions, Constants } from '~/actions'
import PaginationSearch from '../utils/PaginationSearch'

import BlueprintDialogSelector from '~/editors/blueprints/BlueprintDialogSelector'
import { List, SplitPane, Screen, YesNoDialog, TextInput, LabelGroup, Loading } from '~/views'

import style from './style.css'

class DevicesScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }

  constructor( props, context ) {
    super( props, context );
    this.onEvent = this.onEvent.bind( this );
    this.onDeviceChange = this.onDeviceChange.bind( this );
    this.onBlueprintSelected = this.onBlueprintSelected.bind( this )

    this.pager = new PaginationSearch( this, 'devices', ( props, opts ) => {
      opts.blueprint = 'header'
      opts.accessToken = true
      const { params } = this.props.match
      this.props.dispatch( DeviceActions.getDevices( params.systemId, opts ) )
    } )

    const qParsed = props.location.search && qs.parse( props.location.search.slice( 1 ) )

    this.state = { 
      selectedId : qParsed && qParsed.selected || null, 
      showDialog : false, 
      removeDevice : null, 
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props )
    }

    props.dispatch( HistoryActions.addQuery( {
      name : 'test',
      query : {
        getEnd : () => Date.now(),
        getStart : () => Date.now() - 60 * 1000 * 60 * 48,
        type : 'device'
      }
    } ) )
  }

  componentDidMount() {
    this.pager.loadPage( this.props )
  }

  componentWillReceiveProps( next ) {
    const sys = next && next.devices && next.devices.system
    if ( sys ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${sys.projectId}/system` }, { name : sys.name } ] ) )
    }

    this.pager.loadIfNeeded( next )
  }

  onEvent( event, item ) {
    console.log( 'propts', this.props )
    const { history, dispatch, location } = this.props
    if ( event == 'select' ) {
      this.setState( { selectedId : item.id } );
    } else if ( event == DeviceItem.DUPLICATE_DEVICE_EVENT ) {
      const clone = { blueprintId : item.blueprintId,
                      name : `${item.name} copy`, 
                      simulated : !!item.simulated,
                      tags : ObjectUtil.copy( item.tags || null ),
                      metadata : ObjectUtil.copy( item.metadata || null ) }
      dispatch( DeviceActions.addDevice( item.systemId, clone, { accessToken : true } ) )
    } else if ( event == DeviceItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeDevice : item } )
    } else if ( event == DeviceItem.START_EVENT ) {
      dispatch( DeviceActions.startDevice( item ) )
    } else if ( event == DeviceItem.RESET_EVENT ) {
      dispatch( DeviceActions.resetDevice( item ) )
    } else if ( event == DeviceItem.PAUSE_EVENT ) {
      dispatch( DeviceActions.pauseDevice( item ) )
    } else if ( event == DeviceItem.OPEN_LOG_EVENT ) {
      dispatch( DeviceActions.logDevice( item ) )
    } else if ( event == DeviceItem.SIM_CONTROL_EVENT ) {
      history.push( `${location.pathname}/${item.id}/sim` )
    } else if ( event == DeviceItem.HISTORY_EVENT ) {
      history.push( `${location.pathname}/${item.id}/history` )
    }
  }

  onDeviceChange( event ) {

    DeviceUpdater( this.props.dispatch, event.target )
      .set( event.path, event.value )
      .done();
  }

  onBlueprintSelected( item, simulated ) {
    const { dispatch } = this.props
    const device = { blueprintId : item.id, name : `${item.name} Device`, simulated }
    dispatch( DeviceActions.addDevice( this.props.match.params.systemId, device, { accessToken : true } ) )

    this.setState( { showDialog : false } )
  }

  onPromptRemoveYes = () => {
    const { dispatch } = this.props
    const { removeDevice } = this.state
    dispatch( DeviceActions.removeDevice( removeDevice ) )
    this.setState( { showRemoveDialog : false, removeDevice : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeDevice : null } )
  }

  render() {
    const sysId = this.props.match.params.systemId
    const { devices, networks, blueprints, history } = this.props
    // console.log( history )
    const { removeDevice, showRemoveDialog, selectedId, start, search } = this.state
    const isSelected = function( item ) { return item && item.id == selectedId; }

    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()

    const loading = devices.status == Constants.STATUS_LOADING
    const items = devices.systemId == sysId ? this.pager.getPageItems() : []

    const left = (
      <div className={style.left}>
        <List className={style.list}
          onEvent={this.onEvent}
          isSelected={isSelected}
          noItemsView={!loading ? null : <NoDevicesView />}
          items={items}
          itemView={DeviceItem}
          itemProps={{ blueprints, networks }} />

        <div className={style.pagination}>
          <Pagination
            innerClass={classnames( 'pagination', style.innerPagination )}
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={this.pager.onPageChange} />
        </div>
        <Loading show={loading} message="Loading..." />
      </div>
    )
    let details = null
    if ( selectedId ) {
      // get the selected object
      const selected = ArrayUtil.find( items, 'id', selectedId )
      details = DeviceFactory.createEditor( selected, { networks, device : selected, onChange : this.onDeviceChange } );
    }
    const right = <div className={style.right}>{details}</div>
    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <span>
            <Text variant="screenTitle" style={{ display : 'inline' }}>Devices</Text> 
            { total ? (
              <span className={style.count}>
                (
                {' '}
                {start}
                {' '}
                -
                {' '}
                {Math.min( total, start + perPage )}
                {' '}
                out of
                {' '}
                {total}
                {' '}
                )
              </span>
            ) : null }
          </span>
          <div style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <label><i className="fa fa-search" /></label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={() => { this.setState( { showDialog : true } ) }}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New Device
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          <SplitPane style={{ height : '100%' }} left={left} right={right} />
        </Screen.Content>

        <BlueprintDialogSelector
          projectId={this.props.match.params.projectId} 
          show={this.state.showDialog} 
          onClose={() => { this.setState( { showDialog : false } ) }} 
          onItemSelected={this.onBlueprintSelected}
          showFlag
          flagName="Simulated"
          initialFlag={false}
          message="Select the type of device to add" />

        <YesNoDialog show={showRemoveDialog} 
          title={`Remove ${removeDevice && removeDevice.name}?`}
          message={<div>Are you sure you want to delete the device?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
        
      </Screen>
    );
  }
} 

export default withRouter( connect(
  state => ( {
    devices : state.devices,
    blueprints : state.blueprints,
    networks : state.networks,
  } )
)( DevicesScreen ) )
